import { useQuery } from "@tanstack/react-query";
import { api, BACKEND_URL } from "@/lib/api";

export const PLATFORM_LABELS = { instagram: "Instagram", facebook: "Facebook", youtube: "YouTube Shorts", pinterest: "Pinterest", whatsapp: "WhatsApp Channel", telegram: "Telegram" };
export const PLATFORM_FIELDS = {
  instagram: [["instagram", "Instagram caption"]],
  facebook: [["facebook", "Facebook caption"]],
  youtube: [["youtube_title", "YouTube Shorts title"], ["youtube_description", "YouTube Shorts description"]],
  pinterest: [["pinterest_title", "Pin title"], ["pinterest_description", "Pin description"]],
  whatsapp: [["whatsapp", "WhatsApp Channel message"]],
  telegram: [["telegram", "Telegram message"]],
};
export const FORMAT_LABELS = { square: "Instagram / WhatsApp square 1080×1080", story: "Stories, Reels & Shorts 1080×1920", facebook: "Facebook post 1200×630", pin: "Pinterest Pin 1000×1500" };
export const ITEM_STATUS_LABELS = { draft: "Draft", ready: "Ready for review", approved: "Approved", rejected: "Rejected" };
export const POST_STATUS_LABELS = { scheduled: "Scheduled", publishing: "Posting…", due: "Due - post now", published: "Published", failed: "Failed", cancelled: "Cancelled" };

export const useSmmConnections = () =>
  useQuery({ queryKey: ["smm-connections"], queryFn: () => api.get("/admin/smm/connections").then((r) => r.data), staleTime: 60000 }).data || {};

export const media = (path) => (path?.startsWith("/api/") ? `${BACKEND_URL}${path}` : path);

const IST = "Asia/Kolkata";
export const fmtIST = (iso) => new Date(iso).toLocaleString("en-IN", { timeZone: IST, day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", hour12: true });
export const istDay = (d = new Date()) => new Date(d).toLocaleDateString("en-CA", { timeZone: IST });
export const istTime = (iso) => new Date(iso).toLocaleTimeString("en-GB", { timeZone: IST, hour: "2-digit", minute: "2-digit" });
// "YYYY-MM-DDTHH:MM" in IST for <input type="datetime-local">
export const istLocal = (iso) => `${istDay(iso)}T${istTime(iso)}`;
export const addDays = (day, n) => {
  const d = new Date(`${day}T12:00:00+05:30`);
  d.setDate(d.getDate() + n);
  return istDay(d);
};
